<template>
    <div style="padding-top:80px" v-if="is_show">
        <div class="from d">
            <div class="from-title">
                <span>意见反馈</span>
            </div>
            <div style="width: 15rem;margin: 0 auto;"> 
                <textarea style="width: 15rem;height: 6rem;" @input="inputArea()" v-model="form.text" placeholder="描述遇到的问题,需要获得反馈结果可以留下联系方式:不超过250个字" ></textarea>
            </div>

            <div class="submit">
                <button @click="submit">提交</button>
            </div> 
        </div>
       
        <div>
            <div class="from-title">
                <span>反馈记录</span>
            </div>
            <li v-for="(item,index) in feedback" :key="index">
                <div>时间: {{item.feedback_time}}</div>
                <div>内容: {{item.feedback_text}}</div>
                <div>回复: {{item.feedback_note}}</div>
                <hr>
            </li>
        </div>
        
        <!-- 组件使用 -->
        <syalert ref="syalert_id" />

    </div>
</template>

<script>

    import sy from "@/sy";

	// 组件引入
	import syalert from '@/components/syalert.vue';

export default {
    // 组件注册
    components:
    {
        syalert,
    },
    data(){
        return{
            is_show:false,
            form:
            {
                text: '',
            },
            feedback: [],
        }
    },
    methods:{
        inputArea()
        {
            this.currentLength = this.form.text.length
            if (this.currentLength > 250 )
            {
                this.form.text = this.form.text.slice(0, 250)
            }
        },
        submit:function(){

            let $_this=this;
            sy.http.get(
            {
                url: this.$root.API + 'Feedback/Add',
                data: 
                {
                    text: $_this.form.text,
                },
                success: function(res)
                {
                    $_this.$refs.syalert_id.syalert(res.msg);
                    setTimeout(function () {
                        $_this.check();
                    }, 3000);
                }
            });
        },
        check:function()
        {
            let $_this=this;
            sy.http.get(
            {
                url: this.$root.API + 'Feedback/Get',
                success: function(res)
                {
                    $_this.feedback = res.data;
                }
            });

        },
    },
    created(){

        this.is_show = true;
        this.check();
    },
    mounted(){}

}
</script>